import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ChartComponent} from './chart/chart.component';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['../../../app.component.scss', './dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('chartComponent') chartComponent?: ChartComponent;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.chartComponent?.initEmotion();
  }
}
